"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});

var _withStyles = _interopRequireDefault(require("./withStyles"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/~/@material-ui/styles/withStyles/index.js
// module id = 941
// module chunks = 0